var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolling-text-container",staticStyle:{"font-size":"14px","color":"#606266"}},[_c('div',{staticClass:"scrolling-text",style:({
    animationDuration: `${_vm.speed}s`,
  })},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }